export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        
      },
      "fr": {
        "departure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Départ"])},
        "left_his_position_as": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["a quitté son poste de"])},
        "published_on": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Publié le"])},
        "see_profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir son profil"])}
      }
    }
  })
}
